const Modal = ({ message, onConfirm, onCancel, loading }) => {
  return (
    <div className="fund-modal-backdrop">
      <div className="fund-modal-box">
        <p className="fund-modal-message">{message}</p>
        <div className="fund-modal-buttons">
          <button
            className="fund-modal-btn confirm"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Processing..." : "Yes"}
          </button>
          <button
            className="fund-modal-btn cancel"
            onClick={onCancel}
            disabled={loading}
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
